module.exports = __webpack_public_path__ + "static/img/21.2905575.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/21.png
// module id = +6TD
// module chunks = 0